// app/shared/store/notificationsStore.ts
import { create } from 'zustand';

// ### CODE CHANGES START ###
// Define and Export ToastVariant here
export type ToastVariant = "default" | "success" | "error" | "warning" | "info";
// ### CODE CHANGES FINISH ###

export interface AppNotification { // AppNotification now uses the exported ToastVariant
  id: string;
  type: ToastVariant; // Use the defined ToastVariant type
  title: string;
  message: string;
  link?: string; 
  duration?: number;
  // Add action data to support auto-dismissal by use case ID
  action?: {
    data?: {
      useCaseId?: string;
      [key: string]: any;
    };
  };
}

interface NotificationState {
  notifications: AppNotification[];
  addNotification: (notification: Omit<AppNotification, 'id'>) => void;
  dismissNotification: (id: string) => void;
  dismissNotificationsByUseCaseId: (useCaseId: string) => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  addNotification: (notification) =>
    set((state) => ({
      notifications: [...state.notifications, { ...notification, id: Date.now().toString() }],
    })),
  dismissNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
  dismissNotificationsByUseCaseId: (useCaseId) =>
    set((state) => ({
      notifications: state.notifications.filter((notification) => {
        // Check if the notification's action data contains the use case ID
        const actionData = notification.action?.data;
        if (actionData && typeof actionData === 'object' && 'useCaseId' in actionData) {
          return actionData.useCaseId !== useCaseId;
        }
        return true; // Keep notifications that don't have use case ID data
      }),
    })),
}));